import { render, staticRenderFns } from "./CommunicationPopup.vue?vue&type=template&id=5f613e48"
import script from "./CommunicationPopup.vue?vue&type=script&lang=ts"
export * from "./CommunicationPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports